<app-dashboard-wrapper
  title="{{ 'dashboard-broker.component.broker_title' | localise: 'Broker' }}"
  [loading]="loading">
  @if (!!broker?.id) {
    <div class="questions-form forms-support-dark-mode">
      @if (!loading) {
        <app-brokerage-form
          [selectedBroker]="broker"
          [selectedCommissionIssuer]="commissionIssuer"
          [form]="form"
          [showQuestions]="false"
          [showTransactionsInfoFields]="false"
          [readonly]="false"
          [error]="error"
          submitButtonText="{{
            'dashboard-broker.component.broker_save_button' | localise: 'Save'
          }}"
          formTitle="{{
            'dashboard-broker.component.broker_form_title' | localise: 'Save'
          }}"
          (submitForm)="save()"
          [formSubTitle]="''"></app-brokerage-form>
      }
    </div>
  }

  @if (partners?.length) {
    <mat-card class="partner-card">
      <mat-card-title>
        {{ 'dashboard-broker.component.Partner_title' | localise: 'Partner' }}
      </mat-card-title>
      @for (partner of partners; track partner) {
        <div class="content f-s-18">
          <div class="content-block">
            {{
              'dashboard-upcoming-deals.component.partner_name'
                | localise: 'Partner Name'
            }}
            {{ partner.name }}
          </div>
          <div class="f-s-18">
            {{
              'dashboard-broker.component.branch_name' | localise: 'Branch Name'
            }}
            {{ partner.branchName }}
          </div>
        </div>
      }
    </mat-card>
  }
</app-dashboard-wrapper>
